import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { useState } from 'react';
import { ApiError } from './api/client';
import { AuthProvider } from './auth/AuthProvider';
import { crearRouter } from './router';

export function crearQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        // No reintentar errores de negocio (4xx); sí errores de red o 5xx, pocas veces (conexiones lentas).
        retry: (n, e) => !(e instanceof ApiError && e.status >= 400 && e.status < 500) && n < 2,
      },
      mutations: { retry: false },
    },
  });
}

export function App() {
  const [qc] = useState(crearQueryClient);
  const [router] = useState(() => crearRouter());
  return (
    <QueryClientProvider client={qc}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  );
}
